import {BehaviorSubject} from "rxjs";
import {StoreConstants} from '../constants/store.constants';

export const AppActions = {
  menuClicked$: (menuClicked$: BehaviorSubject<boolean>) => ({
    group: StoreConstants.StoreGroups.App,
    type: StoreConstants.App.MENU_CLICKED$,
    menuClicked$
  }),
  showMenu$: (showMenu$: BehaviorSubject<boolean>) => ({
    group: StoreConstants.StoreGroups.App,
    type: StoreConstants.App.SHOW_MENU$,
    showMenu$
  }),
  mousePosition$: (mousePosition$: BehaviorSubject<any>) => ({
    group: StoreConstants.StoreGroups.App,
    type: StoreConstants.App.MOUSE_POSITION$,
    mousePosition$
  }),
  menuRefresh$: (menuRefresh$: BehaviorSubject<number>) => ({
    group: StoreConstants.StoreGroups.App,
    type: StoreConstants.App.MENU_REFRESH$,
    menuRefresh$
  }),
  menuItems$$: (menuItems$$: Array<any> | null) => ({
    group: StoreConstants.StoreGroups.App,
    type: StoreConstants.App.MENU_ITEMS$$,
    menuItems$$
  }),
  state$: (state$: BehaviorSubject<any>) => ({
    group: StoreConstants.StoreGroups.App,
    type: StoreConstants.App.STATE$,
    state$
  }),
  settings: (settings: any) => ({
    group: StoreConstants.StoreGroups.App,
    type: StoreConstants.App.SETTINGS,
    settings
  }),
  subscribers: (subscribers: any) => ({
    group: StoreConstants.StoreGroups.App,
    type: StoreConstants.App.SUBSCRIBERS,
    subscribers
  }),
  dbReady: (dbReady: boolean) => ({
    group: StoreConstants.StoreGroups.App,
    type: StoreConstants.App.DB_READY,
    dbReady
  }),
  deviceReady: (deviceReady: boolean) => ({
    group: StoreConstants.StoreGroups.App,
    type: StoreConstants.App.DEVICE_READY,
    deviceReady
  }),
  cacheReady: (cacheReady: boolean) => ({
    group: StoreConstants.StoreGroups.App,
    type: StoreConstants.App.CACHE_READY,
    cacheReady
  }),
  storeReady: (storeReady: boolean) => ({
    group: StoreConstants.StoreGroups.App,
    type: StoreConstants.App.STORE_READY,
    storeReady
  }),
  activeDialogId: (activeDialogId: string) => ({
    group: StoreConstants.StoreGroups.App,
    type: StoreConstants.App.ACTIVE_DIALOG_ID,
    activeDialogId
  }),
  language: (language: string) => ({
    group: StoreConstants.StoreGroups.App,
    type: StoreConstants.App.LANGUAGE,
    language
  }),
  isOnline: (isOnline: boolean) => ({
    group: StoreConstants.StoreGroups.App,
    type: StoreConstants.App.IS_ONLINE,
    isOnline
  }),
  noImage: (noImage: any) => ({
    group: StoreConstants.StoreGroups.App,
    type: StoreConstants.App.NO_IMAGE,
    noImage
  })
};
